"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typography = void 0;
// (C) 2020 GoodData Corporation
var Typography_1 = require("./Typography");
Object.defineProperty(exports, "Typography", { enumerable: true, get: function () { return Typography_1.Typography; } });
//# sourceMappingURL=index.js.map